import { Fragment, useState } from 'react'

export const Notice = ({ notice }: { notice: string | null }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  if (!notice) return null

  const lines = notice.split('\n')
  const shouldShowExpandButton = lines.length > 2

  return (
    <div>
      <p className="text-secondary-300 overflow-hidden break-words text-xs">
        {isExpanded ? (
          lines.map((part, i) => (
            <Fragment key={i}>
              {part}
              <br />
            </Fragment>
          ))
        ) : (
          <>
            {lines.slice(0, 2).map((part, i) => (
              <Fragment key={i}>{part}</Fragment>
            ))}
            <br />
            {shouldShowExpandButton && '...'}
          </>
        )}
      </p>
      {shouldShowExpandButton && (
        <button
          className="text-primary-500 text-xs hover:underline"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Collapse' : 'Read more'}
        </button>
      )}
    </div>
  )
}
